import React, { forwardRef, memo, useContext } from "react";
import clsx from "clsx";
import ReactSelect, { mergeStyles, Props } from "react-select";

import { BrandingColorContext } from "components/contexts";

import DropdownIndicator from "./dropdownIndicator";
import { selectStyles } from "./selectStyles";
import Skeleton from "../skeleton";

import classes from "./selectAsync.module.scss";

export type SelectProps = Props<any, boolean> & {
	containerClassName?: string;
	loaderClassName?: string;
	menuPlacement?: string;
	classNameCol?: string;
	label?: string;
	className?: string;
	widthSkeleton?: string;
	dataAutotest?: string;
	hideLabel?: boolean;
	blurLoading?: boolean;
	hideRequiredMark?: boolean;
	showRequiredMark?: boolean;
	loading?: boolean;
	disableSkeleton?: boolean;
	brandingColor?: boolean;
	styles?: any;
	hasError?: boolean;
	defaultOptions?: boolean;
	isMulti?: boolean;
	colSelect?: { [key: string]: any };
	colLabel?: { [key: string]: any };
	preselect?: { [key: string]: any };
	errors?: { [key: string]: any };
	items?: { [key: string]: any }[];
	onChange?: (value: any, { action }: { [key: string]: any }) => void;
	control?: any;
	components?: any | { [key: string]: any };
};

const Select = forwardRef<any, SelectProps>(
	(
		{
			loading,
			menuPlacement = "auto",
			loaderClassName,
			widthSkeleton = "100%",
			disableSkeleton,
			styles: customSelectStyles = {},
			components: customComponents = {},
			dataAutotest,
			...props
		},
		ref,
	) => {
		const noValueSelected =
			props?.value?.value === "" || props?.value === null;

		const isBrandingColor = useContext(BrandingColorContext);
		const brandingColorClassName =
			!noValueSelected && isBrandingColor && "branding-color-container";

		const styles =
			mergeStyles(selectStyles, customSelectStyles) ||
			props.brandingColor;

		const components = {
			DropdownIndicator,
			...customComponents,
		};

		return (
			<div
				className={classes.selectLoaderContainer}
				data-autotest={dataAutotest}
			>
				{loading && !disableSkeleton && (
					<Skeleton
						height="34px"
						width={widthSkeleton}
						className={clsx(
							classes.selectLoaderContainerSkeleton,
							loaderClassName,
						)}
					/>
				)}
				{!loading && (
					<ReactSelect
						ref={ref}
						className={clsx(
							"react-select-container",
							brandingColorClassName,
						)}
						classNamePrefix="react-select"
						styles={styles}
						menuPlacement={menuPlacement}
						components={components}
						{...props}
					/>
				)}
			</div>
		);
	},
);

export default memo(Select);
